import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { pathFromLocationState } from '../utils/authRedirect';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      setError('');
      setLoading(true);
      await login(email, password);
      navigate(pathFromLocationState(location.state) || '/', { replace: true });
    } catch (err: any) {
      setError(err.message || 'Could not log in. Check your email and password.');
      console.error('Login error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ss-sheet ss-auth">
      <p className="ss-kicker">Spin &amp; Solve</p>
      <h1 className="ss-title">Log in</h1>
      <p className="ss-sub">Use the email you signed up with. Then you can host or join a room.</p>

      {error && (
        <div className="ss-error" role="alert">
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <label htmlFor="email" className="ss-label">
          Email
        </label>
        <input
          type="email"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="ss-input"
          required
          autoComplete="email"
          placeholder="you@example.com"
        />

        <label htmlFor="password" className="ss-label">
          Password
        </label>
        <input
          type="password"
          id="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="ss-input"
          required
          autoComplete="current-password"
          placeholder="Your password"
        />

        <button type="submit" disabled={loading} className="ss-btn ss-btn-primary" style={{ width: '100%' }}>
          {loading ? 'Signing in' : 'Log in'}
        </button>
      </form>

      <div className="ss-auth-links">
        <Link to="/forgot-password" className="ss-inline-link">
          Forgot password
        </Link>
        <p className="ss-who">
          No account yet?{' '}
          <Link to="/signup" state={location.state} className="ss-inline-link" style={{ marginTop: 0 }}>
            Create one
          </Link>
        </p>
        <Link to="/" className="ss-inline-link">
          Back home
        </Link>
      </div>
    </div>
  );
};

export default Login;
